import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Trust badge shown when the product's seller has completed Stripe Connect
 * onboarding (KYC verified, payouts wired up). Two sizes:
 *   - "sm" (default) for product cards in grids — single icon + short label
 *   - "md" for product detail page hero — slightly larger, full label
 *
 * Render-as-null when `verified` is falsy so callers don't need a guard.
 */
export const VerifiedSellerBadge = ({ verified, size = 'sm', className = '' }) => {
  if (!verified) return null;

  const isMd = size === 'md';
  const padding = isMd ? 'px-2.5 py-1' : 'px-2 py-0.5';
  const text = isMd ? 'text-xs' : 'text-[10px]';
  const iconSize = isMd ? 'w-3.5 h-3.5' : 'w-3 h-3';

  return (
    <span
      className={`inline-flex items-center gap-1 ${padding} rounded-full bg-[#00FF94]/10 border border-[#00FF94]/30 text-[#00FF94] font-semibold ${text} tracking-wide ${className}`}
      title="Verified seller — payouts wired up via Stripe Connect"
      data-testid="verified-seller-badge"
    >
      <ShieldCheck className={iconSize} aria-hidden="true" />
      <span>Verified seller</span>
    </span>
  );
};

export default VerifiedSellerBadge;
